import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const withAuth = (Component) => {
  return (props) => {
    const navigate = useNavigate();
    
    useEffect(() => {
      // Check authentication whenever the component mounts
      const isAuthenticated = localStorage.getItem('gallery3_authenticated') === 'true';
      if (!isAuthenticated) {
        navigate('/', { replace: true });
      }
    }, [navigate]);
    
    return <Component {...props} />;
  };
};

export default withAuth; 